// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconInputArrowDown = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" viewBox="0 0 11 7">
            <polygon
                fill="currentColor"
                points="5.499 6.997 5.981 6.475 10.518 1.566 11 1.044 10.036 .003 9.554 .525 5.499 4.915 1.443 .522 .961 0 0 1.044 .482 1.566 5.016 6.478 5.499 7"
            />
        </svg>
    );
};

export default React.memo(IconInputArrowDown);
